import { HttpClient } from '../HttpClient';
/**
 * * Get Tranasction History
 **/

export const GetTransactionHistory = async ({
  PageNumber,
  RowsPerPage,
  SortOrder,
  Category,
}) => {
  try {
    const response = await HttpClient.get(`/api/v1/loans/history`, {
      params: {
        PageNumber,
        RowsPerPage,
        SortOrder,
        Category,
      },
    });
    return await Promise.resolve(response);
  } catch (err) {
    return Promise.reject(err);
  }
};
